import { render, staticRenderFns } from "./CreateContentplan.pug?vue&type=template&id=483af313&lang=pug&external"
import script from "./CreateContentplan.js?vue&type=script&lang=js&external"
export * from "./CreateContentplan.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports